import { FC, ComponentType } from 'react';
import { Icon, ValidIcons } from '@kizen/kds/Icon';
import { createPortal } from 'react-dom';

const CircleButton = ({
  id,
  circleColor,
  circleIcon,
  onClick,
  zIndex,
  offset,
  CustomIcon,
}: {
  id: string;
  circleColor: string;
  circleIcon: string;
  onClick: () => void;
  zIndex: number;
  offset: number;
  CustomIcon?: ComponentType<any> | null;
}) => {
  return (
    <div
      key={id}
      id={id}
      className="kds w-[48px] h-[48px] rounded-full flex items-center justify-center bg-[var(--circle-color)] select-none pointer-events-auto mt-[10px]"
      style={
        {
          '--circle-color': circleColor || 'var(--color-viz-cat-2-secondary)',
          zIndex: zIndex + offset,
        } as any
      }
    >
      <div
        className="flex items-center justify-center cursor-pointer text-[var(--icon-color)] w-[48px] h-[48px]"
        style={{ '--icon-color': 'var(--color-font-white)' } as any}
        onClick={onClick}
      >
        {CustomIcon ? (
          <CustomIcon className="h-[30px] w-[30px]" />
        ) : (
          <Icon
            icon={`custom-${circleIcon}` as ValidIcons}
            color="background-white"
          />
        )}
      </div>
    </div>
  );
};

export const CirclePortal: FC<{
  id: string;
  hidden?: boolean;
  triggerElement: string;
  circleColor: string;
  circleIcon: string;
  onClick: () => void;
  zIndex: number;
  offset: number;
  side: 'left' | 'right';
  CustomIcon?: ComponentType<any> | null;
}> = ({
  id,
  hidden,
  triggerElement,
  circleColor,
  circleIcon,
  onClick,
  zIndex,
  offset,
  side,
  CustomIcon,
}) => {
  const element = document.getElementById(`${triggerElement}-${side}`);
  if (!element || hidden) {
    return null;
  }

  return createPortal(
    <CircleButton
      id={id}
      circleColor={circleColor}
      circleIcon={circleIcon}
      onClick={onClick}
      zIndex={zIndex}
      offset={offset}
      CustomIcon={CustomIcon}
    />,
    element
  );
};
